import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTransferFeeValue } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import { VEHICLES } from '../../modules/constants';
import precise from '../../modules/precise';
import transferFeeTotal from '../../selectors/transferFeeTotal.selector';
import TextInput from '../../components/TextInput';

class TotalTransferFee extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.getOptions()[event.target.selectedIndex][0];
    this.props.setTransferFeeValue(precise(value), value, label);
  }

  getOptions() {
    const { selectedVehicleType, BFfee, applyCredit, pipe } = this.props;

    const defaultOptions = [
      ['Renewal/No Transfer Fee', 0.00],
      ['Transfer Fee', 4.60],
      ['Transfer Fee outside Classes', 9.10],
    ];

    const motorVehicleOptions = [
      ['Renewal/No Transfer Fee', 0.00],
      ['Transfer Fee', 4.10 + BFfee],
      ['Transfer Fee outside Classes', 8.60 + BFfee],
    ];

    const vesselOptions = [
      ['Renewal/No Transfer Fee', 0.00],
      ['VS Transfer Fee', 1.00],
    ];

    const creditOptionsR16is5 = [
      ['Vessel Transfer Fee', 2.50 + BFfee],
    ];

    const creditOptions = [
      ['Transfer Fee', 4.10 + BFfee],
      ['Transfer Fee outside Classes', 8.60 + BFfee],
    ];

    if (applyCredit && Number(pipe.r16) === 5) {
      return creditOptionsR16is5;
    } else if (applyCredit && Number(pipe.r16) !== 5) {
      return creditOptions;
    } else if (!applyCredit && selectedVehicleType === VEHICLES.VESSELS) {
      return vesselOptions;
    } else if (
      !applyCredit &&
      (selectedVehicleType === VEHICLES.MOTOR_VEHICLE ||
      selectedVehicleType === VEHICLES.LEASE_HIRE_TRAILER ||
      selectedVehicleType === VEHICLES.BUSES_TRAILER ||
      selectedVehicleType === VEHICLES.HEAVY_TRUCKS)
    ) {
      return motorVehicleOptions;
    }

    return defaultOptions;
  }

  render() {
    const { transferFee, transferFeeSelectedValue, transferFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Registration-transferFeeRow">

        <TextInput
          id="totalTransferFee"
          data-id="Rsub5"
          tooltip="$100 Initial Registration Fee"
          value={transferFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="Transfer"
          tooltip="Transfer Fees required"
          options={this.getOptions()}
          onChange={this.onValueSelect}
          selectedValue={transferFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{transferFeeSelectedValueLabel || 'Transfer Fee'}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleType: state.registration.selectedVehicleType,
    transferFee: transferFeeTotal(state),
    transferFeeSelectedValue: state.registration.transferFeeSelectedValue,
    transferFeeSelectedValueLabel: state.registration.transferFeeSelectedValueLabel,
    BFfee: state.registration.BFfee,
    pipe: state.registration.pipe,
    applyCredit: state.registration.applyCredit,
  };
};

export default connect(mapStateToProps, { setTransferFeeValue })(TotalTransferFee);
